import { ModelCollection } from '@/modules/core/app/models/ModelCollection';
import { PointItem } from '@/modules/core/ui/models/PointItem';

export class PointItemCollection extends ModelCollection<PointItem> {
  constructor(items: PointItem[] | null = null) {
    super(items, PointItem);
  }

  static mapModel(items: PointItem[] | null = null): PointItemCollection {
    return new this(items);
  }

  static mapFromText(text: string | undefined): PointItemCollection {
    const items: PointItem[] =
      text
        ?.split('*/')
        .map((pointItem: string): PointItem => {
          const points: string[] = pointItem.split('#/');
          return PointItem.mapModel({
            mainPoint: points[0].trim(),
            subPoints: points
              .slice(1)
              .filter(Boolean)
              .map((point: string): string => point.trim())
          });
        })
        .filter((pointItem: PointItem): boolean => !!pointItem.mainPoint) ?? [];

    return PointItemCollection.mapModel(items);
  }
}
